<template>
  <div
    v-if="$hasFeature('track_trace') && $hasPermission('view_tracking_menu')"
    class="order-wrapper payment-wrapper"
    v-bind:class="{ 'is-active': openSlideleft }"
  >
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="trackMenulist"
        :selectedCategory="selectedCategory"
        :preSearchedParams="searchedParams"
        :searchParameters="searchParameters"
        :searchText="searchText"
        :enableSearchPopup="true"
        v-on:searchByParameter="searchByParameter"
        :buttonsList="buttonList"
        @export="exportData"
      />
      <div>
      </div>
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft"
        >
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content">
        <div
          class="content"
          v-infinite-scroll="loadData"
          infinite-scroll-disabled="loadCheck"
          infinite-scroll-throttle-delay="400"
          infinite-scroll-distance="10"
        >
          <div>
            <Row :gutter="20" class="grid-header" type="flex">
              <Col
                v-for="header in trackListConstant"
                :key="header.id"
                :span="header.colSpan"
              >
                {{ header.title }}
              </Col>
              <Col :span="4"> </Col>
            </Row>
            <div v-if="isLoading" class="paymentloader"></div>
            <div class="status-msg my-sm" v-else-if="!list || !list.length">
              <span>
                <svgicon
                  name="empty-location"
                  width="251"
                  height="160"
                  :original="true"
                />
                <p>No Trips available</p>
              </span>
            </div>
            <DetailRow
              v-else
              v-for="(detail, index) in list"
              :key="index"
              :headers="trackListConstant"
              :details="detail"
              :class="getErrorClass(detail)"
            >
            </DetailRow>
          </div>
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter
          :selectedFilters="filterConstant"
          :filters="filters"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply"
          @clearDate="clearDate"
        />
      </div>
    </div>
  </div>
  <div v-else class="loading-app page-not-found">
      <h4>Page not found</h4>
      <p>
        Go back to <router-link :to="{ path: '/indents/outbound' }">Indents</router-link>
      </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import {
  TrackMenu,
  trackListConstant,
  trackStatus,
  filters,
  trackType,
  autoCompleteReason,
  searchParameters,
  buttonList,
} from '@/constants/trackConstants';
import moment from 'moment';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import DetailRow from '@/components/track/Row';

export default {
  components: {
    PrimaryFilter,
    SecFilter,
    FilterWrapper,
    DetailRow,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      trackType,
      autoCompleteReason,
      trackStatus,
      trackListConstant,
      openSlideleft: true,
      defaultValues: {},
      TrackMenu,
      filterConstant: [],
      filters,
      loadCheck: true,
      dashboardFilter: null,
      searchParameters,
      searchedParams: {},
      searchText: 'Search',
      buttonList,
    };
  },
  async created() {
    this.$store.commit('track/initialReset');
    this.setDefaults();
    const fromDashboard = this.$route && this.$route.query.fromDashboard;
    if (fromDashboard) {
      this.constructConstantForFilter();
      const query = this.$route.query;
      if (query.trans) {
        this.searchedParams.transporter = query.trans;
      }
      if (query.transporterId) {
        this.searchedParams.transporterId = query.transporterId;
      }
      if (query.source_name) {
        this.searchedParams.pickup = query.source_name;
      }
      if (query.destination_name) {
        this.searchedParams.dropoff = query.destination_name;
      }
      if (query.vehicle_number) {
        this.searchedParams.vehicleNumber = query.vehicle_number;
      }
      const trackSettings = (this.configurations && this.configurations.track_settings
      && this.configurations.track_settings.custom_fields) || {};
      if (this.searchedParams) {
        const dataKeys = Object.keys(query);
        dataKeys.forEach((key) => {
          if (query[key] !== null) {
            if (trackSettings[key]) {
              this.searchedParams[trackSettings[key]] = query[key];
            } else {
              this.searchedParams[key] = query[key];
            }
          }
        });
      }
    } else {
      this.loadFilters();
      this.constructSearchConstants();
      this.loadSearchFromSession();
    }
    this.dashboardFilter = this.$route && this.$route.query.dashboardFilter;
    if (this.$route && this.$route.query.widgetFilter) {
      this.searchedParams.widgetFilter = this.$route.query.widgetFilter;
      this.searchedParams.type = this.$route.query.type;
    }
    this.search();
  },
  computed: {
    ...mapGetters({
      list: 'track/list',
      isLoading: 'track/isLoading',
      hasEmpty: 'track/hasEmpty',
      filter: 'track/filter',
      configurations: 'app/configurations',
    }),
    selectedCategory() {
      return this.TrackMenu.find(menu => menu.id === 'Trips');
    },
    filterParams() {
      return this.filterConstant && this.filterConstant.flat();
    },
    trackMenulist() {
      return this.TrackMenu.filter(ele =>
        (ele.permission ? this.$hasPermission(ele.permission) : true),
      );
    },
  },
  methods: {
    async exportData(data) {
      try {
        let filter = this.constructFilterPayload();
        const MS_PER_DAY = 1000 * 60 * 60 * 24;
        // throw error popup if selected date range exceeds 31 days
        const dateDiff = Math.ceil(
          (new Date(filter.end) - new Date(filter.start)) / MS_PER_DAY,
        );
        if (dateDiff > 31) {
          this.$errorMessage({
            message: this.$getErr('EXPORT_DATE_RANGE_EXCEED'),
          });
        } else {
          // search query params
          const params = {};
          if (this.searchedParams && Object.keys(this.searchedParams).length) {
            Object.assign(params, { ...this.searchedParams });
          }
          delete this.searchedParams.destination_name;
          filter = Object.assign(params, filter);
          // redirection dashboard filters
          if (this.dashboardFilter) {
            filter = Object.assign(filter, {
              dashboardFilter: this.dashboardFilter,
            });
          }
          filter = this.serializeObject(filter);
          // delete filter.type;
          // delete filter.widgetFilter;
          delete filter.fromDashboard;
          delete filter.destination_name;
          delete filter.source_name;
          delete filter.trackType;
          const result = await this.$store.dispatch('track/export', filter);
          if (result.error) {
            this.$errorMessage({ message: result.error });
          } else if (result.data === 'SUCCESS') {
            this.$successMessage({
              message: this.$getSuccess('EXPORT_VIA_EMAIL'),
            });
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('EXPORT_FAILS') });
      }
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign(
        {},
        this.searchedParams,
        sessionSearchParams,
      );
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    constructSearchConstants() {
      this.searchParameters.forEach(
        param => (this.searchedParams[`${param.query}`] = this.defaultValues[`${param.query}`]),
      );
    },
    setDefaults() {
      if (this.$route && this.$route.query.status) {
        this.defaultValues.status = this.trackStatus.find(
          val =>
            val.value &&
            val.value.toLowerCase() === this.$route.query.status.toLowerCase(),
        );
      } else {
        [this.defaultValues.status] = this.trackStatus;
      }
      if (this.$route && this.$route.query.trackType) {
        this.defaultValues.trackType = this.trackType.find(
          val =>
            val.value &&
            val.value.toLowerCase() ===
              this.$route.query.trackType.toLowerCase(),
        );
      } else {
        [this.defaultValues.trackType] = this.trackType;
      }
      if (this.$route && this.$route.query.end) {
        this.defaultValues.endDate = this.$route.query.end;
      } else {
        this.defaultValues.endDate = moment().toString();
      }
      if (this.$route && this.$route.query.start) {
        this.defaultValues.startDate = this.$route.query.start;
      } else {
        this.defaultValues.startDate = moment().subtract(15, 'days').toString();
      }
      if (this.$route && this.$route.query) {
        this.defaultValues.transporter = this.$route.query.trans;
      }
      if (
        this.$route &&
        this.$route.query &&
        this.$route.query.autoCompleteReason
      ) {
        this.defaultValues.autoCompleteReason = this.autoCompleteReason.find(
          val =>
            val.value &&
            val.value.toLowerCase() ===
              this.$route.query.autoCompleteReason.toLowerCase(),
        );
      } else {
        [this.defaultValues.autoCompleteReason] = this.autoCompleteReason;
      }
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: false,
          },
          {
            type: 'List',
            category: this.filters.STATUS,
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.trackStatus,
            idLabel: 'value',
            queryParamString: 'status',
            optional: true,
          },
          {
            type: 'List',
            category: this.filters.TRACKTYPE,
            default: this.defaultValues.trackType,
            selected: this.defaultValues.trackType,
            list: this.trackType,
            idLabel: 'value',
            queryParamString: 'typeOfTracking',
            optional: true,
          },
          {
            type: 'List',
            category: this.filters.AUTOCOMPLETEREASON,
            default: this.defaultValues.autoCompleteReason,
            selected: this.defaultValues.autoCompleteReason,
            list: this.autoCompleteReason,
            idLabel: 'value',
            queryParamString: 'autoCompleteReason',
            optional: true,
          },
        ],
      ];
    },
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
    searchApply() {
      const dashboardFilter = this.$route.query.dashboardFilter;
      this.$router.replace({ query: { dashboardFilter } });
      if (this.searchedParams && this.searchedParams.fromDashboard) {
        this.searchedParams = {};
      }
      this.search();
    },
    search() {
      this.applyFilters();
      this.openSlideleft = false;
      this.$store.commit('track/setPage', 1);
      this.loadData();
    },
    searchByParameter(params) {
      const dashboardFilter = this.$route.query.dashboardFilter;
      this.$router.replace({ query: { dashboardFilter } });
      this.searchedParams = params;
      this.$store.commit('track/setPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    async loadData() {
      try {
        let filter = this.constructFilterPayload();
        if (filter) {
          filter = Object.assign(filter, this.filter);
          if (this.searchedParams && filter.status && this.searchedParams.fromDashboard) {
            this.searchedParams = {};
          }
          // search query params
          const params = {};
          if (this.searchedParams && Object.keys(this.searchedParams).length) {
            Object.assign(params, { ...this.searchedParams });
          }
          filter = Object.assign(params, filter);
          // if (this.searchedParams.fromDashboard) {
          //   this.searchedParams = {};
          // }

          // redirection dashboard filters
          if (this.dashboardFilter) {
            filter = Object.assign(filter, {
              dashboardFilter: this.dashboardFilter,
            });
          }
          filter = this.serializeObject(filter);
          const result = await this.$store.dispatch('track/filter', filter);
          if (result.error) {
            this.$errorMessage({ message: result.error });
          }
          this.loadCheck = this.hasEmpty;
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    serializeObject(data) {
      const result = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach((key) => {
        if (data[key] || data[key] !== '') {
          result[key] = data[key];
        }
      });
      return result;
    },
    getErrorClass(detail) {
      if (detail.status === 'AUTO COMPLETED') {
        return 'alert-list alert-red';
      }
      return '';
    },
  },
};
</script>
